import React from 'react';
import { Link } from 'react-router-dom';
import { ExternalLink } from 'lucide-react';
export default function ShipmentExternalLink({ id, label, className = '', }) {
    if (!id || !label)
        return null;
    return (React.createElement(Link, { to: `/shipments/${id}`, className: `text-blue-600 hover:underline inline-flex items-center gap-1 ${className}`, target: "_blank", rel: "noopener noreferrer" },
        React.createElement("span", null, label),
        React.createElement(ExternalLink, { className: "h-3 w-3" })));
}
